import { Stack } from '@mantine/core';
import { useUserContext } from '../../providers/UserContext';
import { TrainingEvent } from '../../types/training-event.type';
import { TrainingResponseList } from '../TrainingResponseList';

/** RSVP lists for the logged-in person and each linked child. */
export function MyTrainingsSection({ trainings }: { trainings: TrainingEvent[] }) {
  const { currentPerson, myChildren } = useUserContext();
  if (!currentPerson && myChildren.length === 0) return null;

  return (
    <Stack gap="lg">
      {currentPerson && (
        <TrainingResponseList
          personId={currentPerson.id}
          label="Meine Termine"
          trainings={trainings}
        />
      )}
      {myChildren.map((child) => (
        <TrainingResponseList
          key={child.id}
          personId={child.id}
          label={`Termine von ${child.firstName}`}
          trainings={trainings}
        />
      ))}
    </Stack>
  );
}
